import guitarPlayer from "@/assets/guitar-player.png";
import astronaut from "@/assets/astronaut.jpg";
import pianoMan from "@/assets/piano-man.jpg";
import peddler from "@/assets/peddler.jpg";
import sparkleBanner from "@/assets/sparkle-banner.jpg";

const BandSection = () => {
  const bandMembers = [
    { 
      image: guitarPlayer, 
      name: "Red Bean Tanch", 
      instrument: "Guitar"
    },
    { 
      image: peddler, 
      name: "Buffalo Barfield", 
      instrument: "Bass"
    },
    { 
      image: pianoMan, 
      name: "Evan Jacobs", 
      instrument: "Piano"
    },
    { 
      image: astronaut, 
      name: "Landis Maximus", 
      instrument: "Drums"
    },
    { 
      image: sparkleBanner, 
      name: "D.J.C.", 
      instrument: "DJ"
    },
  ];

  const MemberCard = ({ image, name, instrument, imagePosition }: { 
    image: string; 
    name: string; 
    instrument: string;
    imagePosition?: string;
  }) => (
    <>
      <div className="relative group overflow-hidden aspect-square bg-background">
        <img
          src={image}
          alt={`${name} - ${instrument}`}
          className={`w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-105 ${imagePosition || ''}`}
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      </div>
      <div className="bg-background py-4 text-center border-t border-border">
        <h3 className="font-bold text-[18px] text-foreground uppercase mb-2">
          {name}
        </h3>
        <p className="font-medium text-[14px] text-primary uppercase">
          {instrument}
        </p>
      </div>
    </>
  );

  return (
    <section id="band" className="py-16 md:py-24 bg-background scroll-mt-24">
      <div className="container mx-auto px-4">
        <h2 className="text-[32px] md:text-[36px] font-bold text-center mb-6 tracking-[0.02em] uppercase text-foreground">
          THE NATIONAL BAND OF TEXAS
        </h2>
        <p className="text-center text-lg font-medium text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed">
          Deep in the heart of Texas, a collection of souls have united to jam their way through chaos and strife landing in greener pastures and brighter days. Join the mission and enjoy the journey experiencing the wonderous ways of music and the powerful moments created along the way.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-0 max-w-7xl mx-auto">
          {bandMembers.map((member, index) => (
            <div key={index} className="flex flex-col">
              <MemberCard 
                image={member.image} 
                name={member.name} 
                instrument={member.instrument}
                imagePosition={index === 1 ? 'object-top' : undefined}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BandSection;
